var map = {
	"./attacks.png": 853,
	"./corners.png": 854,
	"./corners_bak.png": 855,
	"./free_kicks.png": 856,
	"./penalties.png": 857,
	"./reds.png": 858,
	"./shots_off_target.png": 859,
	"./shots_on_target.png": 860,
	"./yellows.png": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;